<template>
  <div class="flexJC alignItem" style="margin-top: 50px;" id="state">
<button
      class="btn-lx btn-lx-big mb10 btn-width"
      style="width: 300px;"
      @click="goTo()"
    >
      请点击跳转到租借归还首页
    </button>
  </div>
</template>
<script>
import userServ from '../service/userServ'
import mintUi from "../lib/mint-ui";
export default {
  name: 'state',
  methods: {
    goTo() {
      //带参数跳转
      let qrCode = this.$route.query.qrcode
      let bedNo =
        this.$route.query.bedNo && this.$route.query.bedNo != 'null'
          ? this.$route.query.bedNo
          : '1'
      if (userServ.IsWeixinOrAlipay() == 'WeiXIN') {
        this.$router.push({
          path: '/Index',
          query: { qrcode: qrCode, bedNo: bedNo },
        })
      } else if (userServ.IsWeixinOrAlipay() == 'Alipay') {
        this.$router.push({
          path: '/alipayIndex',
          query: { qrcode: qrCode, bedNo: bedNo },
        })
      } else {
        mintUi.MessageBox.alert('请使用微信或者支付宝扫码租借或者归还！！')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/status.vue